<template>
    <div class="mb-8 rounded-md bg-gray-200 p-6 shadow-inner">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-end">
            <template v-for="filter in filters" :key="filter.key">
                <div
                    class="admin-filters-bar__field"
                    :class="filter.widthClass || 'flex w-1/3 flex-col'"
                >
                    <label
                        class="mb-1 text-xs font-semibold uppercase leading-5"
                    >
                        {{ filter.label }}
                    </label>

                    <select
                        v-if="filter.type === 'select'"
                        :value="currentValue(filter.key)"
                        class="rounded p-3 shadow"
                        @change="
                            onInput(
                                filter.key,
                                ($event.target as HTMLSelectElement).value,
                            )
                        "
                    >
                        <option
                            v-for="option in filter.options || []"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.label }}
                        </option>
                    </select>

                    <input
                        v-else
                        :value="currentValue(filter.key)"
                        :placeholder="filter.placeholder || ''"
                        :aria-label="filter.ariaLabel || ''"

                        class="rounded p-3 shadow"
                        type="text"
                        @input="
                            onInput(
                                filter.key,
                                ($event.target as HTMLInputElement).value,
                            )
                        "
                    />
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
type FilterOption = {
    label: string;
    value: string;
};

type FilterField = {
    key: string;
    label: string;
    type: "select" | "text";
    options?: FilterOption[];
    placeholder?: string;
    widthClass?: string;
};

export default {
    props: {
        filters: {
            type: Array as () => FilterField[],
            default: () => [],
        },
        modelValue: {
            type: Object as () => Record<string, string>,
            default: () => ({}),
        },
    },
    emits: ["update:modelValue"],
    methods: {
        currentValue(key: string): string {
            return this.modelValue[key] ?? "";
        },
        onInput(key: string, value: string): void {
            this.$emit("update:modelValue", {
                ...this.modelValue,
                [key]: value,
            });
        },
    },
};
</script>

<style scoped>
@media (max-width: 639px) {
    .admin-filters-bar__field {
        width: 100% !important;
    }
}
</style>
